import React, { useState, useEffect, useRef, useContext } from "react";
import one from "../assets/one.png";
import two from "../assets/two.png";
import three from "../assets/three.png";
import four from "../assets/four.png";
import five from "../assets/five.png";
import six from "../assets/six.png";
import seven from "../assets/seven.png";
import eight from "../assets/eight.png";
import imgLive from "../assets/img_live.gif";
import nine from "../assets/nine.png";
import ten from "../assets/ten.png";
import premium from "../assets/Premium.png";
import rent from "../assets/Rent.png";
import default_horizontal_img from "../assets/placehoder_horizontal.png";
import default_vertical_img from "../assets/placehoder_vertical.png";
import ShadowLayer from "../assets/homescreenlayer.png";
import VideoPlayer from "./HomeBGVideoPlayer";
import RowList from "./RowList";
import { fetchContent } from "../services/api";
import AppInApp from "./AppInApp";
import $ from "jquery";
import { toSentenceCase } from "../utils/utils";
import Wrapper from "./shared/Wrapper";
import view_all from "../assets/view_all.png";
import { getViewAllContent, getlanguagepopular } from "./dataManager";
import { handleViewAll, PaginationData } from "./dataManager";
import SliderBanner from "./SliderBanner";
import upcomingImg from "../assets/upcoming.png";
import {
  getGridResponse,
  getHomeSectionAppinApp,
  getplaylistVideo,
  getRentalStatusByIds,
} from "../services/services";
import { AppContext } from "../AppContext";
import { sendHomeEvent } from "../Analytics/MatomoManager/homeScreenMatomo";

console.log("AnimatedGrid.js", window.RESOLUTION);
let platform = "";

let addKeyListener;
let setFocusToDefault;
let RemoveCurrentKeyListener;
let ShowAppInAppSection;

const AnimatedGrid = ({
  loaderSet,
  data,
  filterTags,
  recomenddata,
  recomenddataFeed,
  columnCount,
  rowHeight,
  rowWidth = "100%",
  columnWidth,
  columnHeight,
  thumbnailWidth,
  thumbnailHeight,
  gapX,
  gapY,
  selectionColor = "#FFFFFF",
  scrollDuration = 300,
  defaultRowCount = 1,
  horizontalScrollStartIndex = 1,
  selectionStyle,
  gridContainerX,
  gridContainerY,
  gridContainerWidth,
  gridContainerHeight,
  gridContainerBgColor,
  shouldFocus,
  navigate,
  shouldFocusToGrid,
  FocusHandler,
  callBack,
  isChild,
  navigateScreen,
  hideRowlist,
  itemDetails,
  appinappData,
  chageAppInAppStatus,
  AppInAppDataResponse,
  bannerdata,
  shouldFocusSlider,
  lastFocusedElement1,
  lastFocusedElement2,
  lastFocusedElement,
  rememberFocus,
  setRememberFocus,
  shouldShowBanner,
  sliderData,
}) => {
  let resolution = window.RESOLUTION;
  const [currentRowIndex, setCurrentRowIndex] = useState(
    rememberFocus?.row || 0
  );
  const [selectedIndex, setSelectedIndex] = useState(
    rememberFocus
      ? { row: rememberFocus.row, col: rememberFocus.col }
      : { row: 0, col: 0 }
  );
  const [scrolling, setScrolling] = useState(false);
  const keyListenerRef = useRef(null);
  const [updateData, onDataUpdate] = useState(data);
  const [count, setCount] = useState(0);
  const [originalData, setoriginalData] = useState(data);
  const { sourceContext, setSourceContext } = useContext(AppContext);
  
  // Create a ref for the background video timer
  const bgVideoTimerRef = useRef(null);
  const animationFrameRef = useRef(null);

  const [state, setState] = useState({
    BgImage: data[0]?.list[0]?.detail_banner
      ? data[0]?.list[0]?.detail_banner
      : data[0]?.list[0]?.poster_url,
    shouldShowBGimage: true,
    shouldShowBGVideo: false,
    tarilerURL: data[0]?.list[0]?.file_url ? data[0]?.list[0]?.file_url : "",
    selectdIndx: 0,
    images: [one, two, three, four, five, six, seven, eight, nine, ten],
    griddata: null,
    pageNumber: 2,
    currentRowIndex: 0,
    isLoading: false,
    lastFetchedRow: null,
    lastFetchedPage: null,
  });

  const {
    BgImage,
    shouldShowBGimage,
    shouldShowBGVideo,
    tarilerURL,
    selectdIndx,
    images,
    griddata,
    pageNumber,
  } = state;

  const masterHit = JSON.parse(localStorage.getItem("masterData"));
  const Teaser_CountDown = masterHit?.data?.teaser_countdown;

  console.log("Teaser_CountDown:", data);

  const handleKeyDown = (e) => {
    if (scrolling) return;

    switch (e.keyCode) {
      case 40:
        setState((prevState) => ({
          ...prevState,
          selectdIndx: 0,
        }));
        selectDown();
        break;
      case 38:
        setState((prevState) => ({
          ...prevState,
          selectdIndx: 0,
        }));
        selectUp();
        break;
      case 39:
        if (selectdIndx < data[currentRowIndex].list.length - 1) {
          selectRight();
        }
        break;
      case 37:
        if (selectdIndx > 0) {
          selectLeft();
        } else if (selectedIndex.col === 0) {
          // Only open menu when focus is on first item (row 0, col 0)
          window.removeEventListener("keydown", handleKeyDown);
          callBack("AnimatedGrid", true);
        } else if (selectdIndx === 0) {
          // Move left normally for other rows when at first column
          selectLeft();
        }
        break;
      case 13:
        handleOk();
        break;
      case 10009:
        window.removeEventListener("keydown", handleKeyDown);
        callBack("AnimatedGrid", true);
        break;
      case 8:
        window.removeEventListener("keydown", handleKeyDown);
        callBack("AnimatedGrid", true);
        break;
      case 461:
        window.removeEventListener("keydown", handleKeyDown);
        callBack("AnimatedGrid", true);
        break;
      default:
        break;
    }
  };

  const listArray =
    data.find((item) => item.playlist_type_id === 2)?.list || [];

  const filteredList = listArray.filter(
    (listItem) => listItem.banner_type === 0
  );
  console.log("AnimatedGrid.js data:", filteredList);

  const fiteredDataForBanner = data.filter((item) => {
    return item.playlist_type_id === 2;
  });

  setFocusToDefault = () => {
    setCurrentRowIndex(0);
    setSelectedIndex({ row: 0, col: 0 });
    if (setRememberFocus) {
      setRememberFocus({ row: 0, col: 0 });
    }
  };

  ShowAppInAppSection = () => {
    setState((prevState) => ({
      ...prevState,
      griddata: null,
    }));
    handleOk();
  };

  RemoveCurrentKeyListener = () => {
    keyListenerRef.current = null;
    keyListenerRef.current = handleKeyDown;
    window.removeEventListener("keydown", keyListenerRef.current);
  };

  addKeyListener = () => {
    if (keyListenerRef.current) return;
    keyListenerRef.current = handleKeyDown;
    window.addEventListener("keydown", keyListenerRef.current);
    
    // Clear any existing timer before setting new one
    if (bgVideoTimerRef.current) {
      clearTimeout(bgVideoTimerRef.current);
      bgVideoTimerRef.current = null;
    }
    
    setState((prevState) => ({
      ...prevState,
      BgImage: data[currentRowIndex]?.list[selectedIndex.col]?.detail_banner
        ? data[currentRowIndex]?.list[selectedIndex.col]?.detail_banner
        : data[currentRowIndex]?.list[selectedIndex.col]?.poster_url,
      shouldShowBGimage: true,
      shouldShowBGVideo: false,
      tarilerURL: data[currentRowIndex]?.list[selectedIndex.col]?.file_url,
    }));

    if (
      data[currentRowIndex]?.list[selectedIndex.col]?.file_url !== undefined &&
      data[currentRowIndex]?.list[selectedIndex.col]?.file_url !== ""
    ) {
      bgVideoTimerRef.current = setTimeout(function () {
        setState((prevState) => ({
          ...prevState,
          shouldShowBGimage: false,
          shouldShowBGVideo: true,
          tarilerURL: data[currentRowIndex]?.list[selectedIndex.col]?.file_url,
        }));
      }, 5000);
    }
  };

  const handleFinished = () => {
    setState((prevState) => ({
      ...prevState,
      shouldShowBGimage: true,
      shouldShowBGVideo: false,
    }));
  };

  const removeKeyListener = () => {
    if (!keyListenerRef.current) return;
    window.removeEventListener("keydown", keyListenerRef.current);
    keyListenerRef.current = null;
    
    // Clear background video timer when removing key listener
    if (bgVideoTimerRef.current) {
      clearTimeout(bgVideoTimerRef.current);
      bgVideoTimerRef.current = null;
    }
  };

  const selectDown = () => {
    setCount(0);
    if (currentRowIndex < data.length - 1) {
      scrollVertical(true);
      resetRowToOriginal(currentRowIndex);
    }
    
    // Clear and reset timer
    if (bgVideoTimerRef.current) {
      clearTimeout(bgVideoTimerRef.current);
      bgVideoTimerRef.current = null;
    }
    
    setState((prevState) => ({
      ...prevState,
      BgImage: data[currentRowIndex]?.list[selectedIndex.col]?.detail_banner
        ? data[currentRowIndex]?.list[selectedIndex.col]?.detail_banner
        : data[currentRowIndex]?.list[selectedIndex.col]?.poster_url,
      shouldShowBGimage: true,
      shouldShowBGVideo: false,
      tarilerURL: data[currentRowIndex]?.list[selectedIndex.col]?.file_url,
    }));
  };

  const selectUp = () => {
    setCount(0);
    if (currentRowIndex > 0) {
      scrollVertical(false);
      resetRowToOriginal(currentRowIndex);
    } else {
      if (shouldShowBanner) {
        FocusHandler("Slider");
      } else {
        FocusHandler("RowList");
      }
      window.removeEventListener("keydown", handleKeyDown);
    }
    
    // Clear and reset timer
    if (bgVideoTimerRef.current) {
      clearTimeout(bgVideoTimerRef.current);
      bgVideoTimerRef.current = null;
    }
    
    setState((prevState) => ({
      ...prevState,
      BgImage: data[currentRowIndex]?.list[selectedIndex.col]?.detail_banner
        ? data[currentRowIndex]?.list[selectedIndex.col]?.detail_banner
        : data[currentRowIndex]?.list[selectedIndex.col]?.poster_url,
      shouldShowBGimage: true,
      shouldShowBGVideo: false,
      tarilerURL: data[currentRowIndex]?.list[selectedIndex.col]?.file_url,
    }));
  };

  const selectRight = () => {
    console.log(
      "selectRightttttt",
      selectedIndex.row,
      selectedIndex.col,
      data[currentRowIndex]?.list.length
    );
    if (
      data[currentRowIndex].playlist_type === "continue_watching" ||
      data[currentRowIndex].playlist_type === "content_language" ||
      data[currentRowIndex].playlist_type === "RecommededFeed" ||
      data[currentRowIndex].playlist_type === "aggregator" ||
      data[currentRowIndex].playlist_type === "popular_genres"
    ) {
      columnCount = 4;
    }

    const nextCol = selectedIndex.col + 1;
    if (nextCol < columnCount && nextCol < data[currentRowIndex]?.list.length) {
      setCount(count + 1);
      const newSelectedIndex = { row: currentRowIndex, col: nextCol };
      setSelectedIndex(newSelectedIndex);
      if (setRememberFocus) {
        setRememberFocus(newSelectedIndex);
      }
      
      // Clear and reset timer
      if (bgVideoTimerRef.current) {
        clearTimeout(bgVideoTimerRef.current);
        bgVideoTimerRef.current = null;
      }
      
      setState((prevState) => ({
        ...prevState,
        BgImage: data[currentRowIndex]?.list[nextCol].detail_banner
          ? data[currentRowIndex]?.list[nextCol].detail_banner
          : data[currentRowIndex]?.list[nextCol].poster_url,
        shouldShowBGimage: true,
        shouldShowBGVideo: false,
        tarilerURL: data[currentRowIndex]?.list[nextCol].file_url,
        selectdIndx:
          selectdIndx < data[currentRowIndex].list.length - 1
            ? selectdIndx + 1
            : data[currentRowIndex].list.length - 1,
      }));
      
      // Set new timer if there's a file URL
      if (
        data[currentRowIndex]?.list[nextCol]?.file_url !== undefined &&
        data[currentRowIndex]?.list[nextCol]?.file_url !== ""
      ) {
        bgVideoTimerRef.current = setTimeout(function () {
          setState((prevState) => ({
            ...prevState,
            shouldShowBGimage: false,
            shouldShowBGVideo: true,
            tarilerURL: data[currentRowIndex]?.list[nextCol]?.file_url,
          }));
        }, 5000);
      }
    } else if (nextCol >= columnCount) {
      setCount(count + 1);
      scrollHorizontal(true);
    }
  };

  const truncateText = (text) => {
    const words = text?.split(" ");
    if (words?.length > 15) {
      return words?.slice(0, 15).join(" ") + " ...";
    }
    return text;
  };

  const resetRowToOriginal = (rowIndex) => {
    const originalList = originalDataRef.current;
    if (!originalList || !originalList[rowIndex]) {
      console.warn("Original list not found for row:", rowIndex, originalList);
      return;
    }

    var updatedDataTemp = updateData;
    updatedDataTemp[rowIndex].list = originalList[rowIndex].list;
    setoriginalData(updatedDataTemp);
  };

  const selectLeft = () => {
    console.log(
      "selectLeftttttt",
      selectedIndex.row,
      selectedIndex.col,
      data[currentRowIndex]?.list.length
    );
    const prevCol = selectedIndex.col - 1;
    if (prevCol >= 0) {
      const newSelectedIndex = { row: currentRowIndex, col: prevCol };
      setSelectedIndex(newSelectedIndex);
      if (setRememberFocus) {
        setRememberFocus(newSelectedIndex);
      }
      
      // Clear and reset timer
      if (bgVideoTimerRef.current) {
        clearTimeout(bgVideoTimerRef.current);
        bgVideoTimerRef.current = null;
      }
      
      setState((prevState) => ({
        ...prevState,
        BgImage: data[currentRowIndex]?.list[prevCol].detail_banner
          ? data[currentRowIndex]?.list[prevCol].detail_banner
          : data[currentRowIndex]?.list[prevCol].poster_url,
        shouldShowBGimage: true,
        shouldShowBGVideo: false,
        tarilerURL: data[currentRowIndex]?.list[prevCol].file_url,
        selectdIndx: selectdIndx > 0 ? selectdIndx - 1 : 0,
      }));
      
      // Set new timer if there's a file URL
      if (
        data[currentRowIndex]?.list[prevCol]?.file_url !== undefined &&
        data[currentRowIndex]?.list[prevCol]?.file_url !== ""
      ) {
        bgVideoTimerRef.current = setTimeout(function () {
          setState((prevState) => ({
            ...prevState,
            shouldShowBGimage: false,
            shouldShowBGVideo: true,
            tarilerURL: data[currentRowIndex]?.list[prevCol]?.file_url,
          }));
        }, 5000);
      }
      
      setCount(count - 1);
    } else {
      scrollHorizontal(false);
      setCount(count - 1);
    }
  };

  const handleViewAllClick = (selectedItem) => {
    let playlist_id = selectedItem.playlist_id;
    let playlist_name = data[currentRowIndex].title[0].content;
    let playlist_type_id = data[currentRowIndex].playlist_type_id;
    let playlist_type = data[currentRowIndex].playlist_type;

    console.log(playlist_name, "palsushj");

    let fetchContentPromise = getViewAllContent(selectedItem);

    fetchContentPromise.then(function (viewAllData) {
      const updatedViewAllData = {
        ...viewAllData,
        playlist_name,
        playlist_type_id,
        playlist_type,
      };
      navigate("ViewAllScreen", updatedViewAllData);
    });

    fetchContentPromise.catch(function () {
      console.log("Error in fetchContentPromise");
    });
  };

  const handlepopularcontent = (data, selectedItem) => {
    let playlist_id = selectedItem.playlist_id;
    let playlist_name = selectedItem.title;
    let playlist_type_id = data.playlist_type_id;
    let playlist_type = data.playlist_type;

    let fetchContentPromise = getlanguagepopular(data, selectedItem);

    fetchContentPromise.then(function (viewAllData) {
      const AppInAppData = data;
      const updatedViewAllData = {
        ...viewAllData,
        playlist_name,
        playlist_type_id,
        playlist_type,
        selectedItem,
        AppInAppData,
      };
      navigate("ViewAllScreen", updatedViewAllData);
    });

    fetchContentPromise.catch(function () {
      console.log("Error in fetchContentPromise");
    });
  };

  const originalDataRef = useRef(null);

  useEffect(() => {
    if (data.length > 0 && !originalDataRef.current) {
      originalDataRef.current = JSON.parse(JSON.stringify(data));
      setoriginalData(originalDataRef.current);
    }
  }, [data]);

  const handleOk = async (rowIndex, colIndex) => {
    if(state.isLoading){
      return;
    }
    
    const currentRow = rowIndex !== undefined ? rowIndex : currentRowIndex;
    const currentCol = colIndex !== undefined ? colIndex : selectedIndex.col;

    if (!data[currentRow] || !data[currentRow].list[currentCol]) {
      console.warn("Invalid selection");
      return;
    }

    const selectedItem = data[currentRow]?.list[currentCol];
    const currentUserId = localStorage.getItem("userId");

    const Ids = selectedItem.video_id
      ? selectedItem.id
      : selectedItem.show_id
        ? selectedItem.show_id
        : selectedItem.id;

    const startTime =
      selectedItem?.endtime !== undefined
        ? parseInt(selectedItem?.endtime) * 1000
        : parseInt(selectedItem?.endtime) * 1000;

    const currentTime = Date.now();

    console.log("selectedItem:", selectedItem, startTime, currentTime);

    if (selectedItem?.is_paid !== null || selectedItem?.is_paid !== undefined) {
      const getRentalStatusByIdsPromise = getRentalStatusByIds(
        Ids,
        currentUserId,
        ""
      );

      getRentalStatusByIdsPromise?.then((rentalStatus) => {
        console.log("rentalStatus:", rentalStatus);
        const isOnRentString = rentalStatus?.data?.[0]?.isOnRent;
        window.IS_ON_RENT = Number(isOnRentString);
      });
    }

    console.log(
      data[currentRow]?.title[0]?.content,
      selectedItem,
      "CheckingList111"
    );

    // Adding sourceContext
    setSourceContext(
      `${sourceContext}/(${data[currentRow]?.id}/${data[currentRow]?.title[0]?.content})`
    );

    // Send Matomo function
    await sendHomeEvent(
      data[currentRow]?.playlist_type,
      currentRow,
      selectedItem,
      data
    );

    if (!selectedItem) {
      console.warn("No valid selected item found.");
      return;
    }

    if (selectedItem.type_id === "view_all" && selectedItem.playlist_type_id) {
      handleViewAllClick(selectedItem);
      return;
    }

    if (
      data[currentRow].playlist_type_id === 9 ||
      data[currentRow].playlist_type_id === 10
    ) {
      handlepopularcontent(data[currentRow], selectedItem);
      return;
    }

    if (data[currentRow].playlist_type_id === 11) {
      fetchData(selectedItem);
      if (hideRowlist) {
        hideRowlist();
      }
    } else {
      if (setRememberFocus) {
        setRememberFocus(selectedIndex);
      }

      const LiveTV = selectedItem.type === 0 && selectedItem.still_live === 1;
      const AudioTv = selectedItem.type === 1 && selectedItem.still_live === 1;
      console.log("selectedItem in handleOk:", selectedItem, selectedItem, data, itemDetails);
const GallaryDetailsScreen=selectedItem?.type===4 ||selectedItem?.type===5||selectedItem?.type==6||selectedItem?.type===7

      window.removeEventListener("keydown", handleKeyDown);

      const continue_watching = selectedItem.paused_at >= 0;
      if (continue_watching) {
        navigateToScreen("HomeDetailsScreen", selectedItem);
        return;
      }

      if(GallaryDetailsScreen){
        navigateToScreen("GallaryDetailsScreen", selectedItem);
        return;
      }
      if (selectedItem.type === 9) {
        console.log("naveen :: LiveEventDetailsScreen navigated");
        navigateToScreen("LiveEventDetailsScreen", selectedItem);
        return;
      }
      if (LiveTV) {
        console.log("naveen :: LiveEventDetailsScreen navigated");
        navigateToScreen("TvRadioDetailsScreen", selectedItem);
        return;
      }

      if (AudioTv) {
        console.log("naveen :: LiveEventDetailsScreen navigated");
        navigateToScreen("TvRadioDetailsScreen", selectedItem);
        return;
      }
      if (selectedItem.type == 1) {
        navigateToScreen("HomeDetailsScreen", selectedItem);
        return;
      }

      if (selectedItem.type == 0) {
        navigateToScreen("HomeDetailsScreen", selectedItem);
      }

      if (lastFocusedElement1) {
        lastFocusedElement1();
      }
    }
  };

  async function fetchData(selectedItem) {
    console.log("fetchData called with selectedItem:", selectedItem);
    if (!selectedItem) {
      console.error("fetchData called with invalid selectedItem.");
      return;
    }
    loaderSet((prevState) => ({
      ...prevState,
      loading: true,
    }));

    const userId = localStorage.getItem("profileId");
    const getCountry = localStorage.getItem("country");
    let updatedGridData = [];

    let myHeaders = {
      platform: "0",
      iskid: "0",
      age: "12",
      country: getCountry,
      Langid: "1",
      lastupdated: "0000000000",
      profileid: userId,
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json",
    };

    try {
      const gridResponse = await getHomeSectionAppinApp(selectedItem.id);

      updatedGridData = handleViewAll(gridResponse?.data);

      if (gridResponse) {
        chageAppInAppStatus(true);
        AppInAppDataResponse("success", updatedGridData);
      } else {
        console.error("No response received from the grid API.");
        AppInAppDataResponse("error", null);
      }

      loaderSet((prevState) => ({
        ...prevState,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
      AppInAppDataResponse("error", null);
    }
  }

  const scrollVertical = (down) => {
    if (scrolling) return;
    setScrolling(true);

    const moveBy = rowHeight + gapY;
    const $grid = $("#grid");

    let newTop;
    if (down) {
      newTop = parseInt($grid.css("top")) - moveBy;
    } else {
      newTop = parseInt($grid.css("top")) + moveBy;
    }

    $grid.animate({ top: newTop + "px" }, scrollDuration, function () {
      const newRowIndex = down ? currentRowIndex + 1 : currentRowIndex - 1;
      setCurrentRowIndex(newRowIndex);
      const newSelectedIndex = { row: newRowIndex, col: 0 };
      setSelectedIndex(newSelectedIndex);
      if (setRememberFocus) {
        setRememberFocus(newSelectedIndex);
      }
      setScrolling(false);

      const currentItem = data[newRowIndex]?.list[0];
      setState((prevState) => ({
        ...prevState,
        BgImage: currentItem?.detail_banner || currentItem?.poster_url,
        shouldShowBGimage: true,
        shouldShowBGVideo: false,
        tarilerURL: currentItem?.file_url,
      }));
    });
  };

  const scrollHorizontal = (right) => {
    if (scrolling) return;
    setScrolling(true);

    const newGridData = [...data];
    const selectedRow = newGridData[currentRowIndex];
    if (selectedRow) {
      if (
        (right && selectedIndex.col < selectedRow.list.length - 1) ||
        (!right && selectedIndex.col >= 0)
      ) {
        const newShows = right
          ? [...selectedRow.list?.slice(1), selectedRow.list[0]]
          : [
            selectedRow.list[selectedRow.list.length - 1],
            ...selectedRow.list?.slice(0, -1),
          ];
        newGridData[currentRowIndex] = { ...selectedRow, list: newShows };

        $(`.grid-row-${currentRowIndex}`).animate(
          { left: `${right ? "-" : "+"}=${columnWidth + gapX}px` },
          scrollDuration,
          function () {
            data[currentRowIndex] = newGridData[currentRowIndex];
            setScrolling(false);
            const newSelectedIndex = {
              row: currentRowIndex,
              col: right ? selectedIndex.col : 0,
            };
            setSelectedIndex(newSelectedIndex);
            if (setRememberFocus) {
              setRememberFocus(newSelectedIndex);
            }
            $(this).css("left", "0");
          }
        );
      } else {
        setScrolling(false);
      }
    }

    let tmpImages = [one, two, three, four, five, six, seven, eight, nine, ten];
    if (selectedRow.playlist_type === "trending") {
      if (selectdIndx === 6) {
        tmpImages = [two, three, four, five, six, seven, eight, nine, ten];
      } else if (selectdIndx === 7) {
        tmpImages = [three, four, five, six, seven, eight, nine, ten];
      } else if (selectdIndx === 8) {
        tmpImages = [four, five, six, seven, eight, nine, ten];
      } else if (selectdIndx === 9) {
        tmpImages = [five, six, seven, eight, nine, ten];
      } else if (selectdIndx === 3) {
        tmpImages = [three, four, five, six, seven, eight, nine, ten];
      } else if (selectdIndx === 2) {
        tmpImages = [two, three, four, five, six, seven, eight, nine, ten];
      } else if (selectdIndx === 1) {
        tmpImages = [one, two, three, four, five, six, seven, eight, nine, ten];
      }
    }
    setState((prevState) => ({
      ...prevState,
      BgImage: data[currentRowIndex]?.list[selectedIndex.col].detail_banner
        ? data[currentRowIndex]?.list[selectedIndex.col].detail_banner
        : data[currentRowIndex]?.list[selectedIndex.col].poster_url,
      shouldShowBGimage: true,
      shouldShowBGVideo: false,
      tarilerURL: data[currentRowIndex]?.list[selectedIndex.col].file_url,
      selectdIndx: right ? selectdIndx + 1 : selectdIndx - 1,
      images: tmpImages,
    }));
  };

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);

    let formattedTime = "";

    if (hours > 0) {
      formattedTime += `${hours}h `;
    }
    if (minutes > 0) {
      formattedTime += `${minutes}m `;
    }

    return formattedTime.trim();
  };

  useEffect(() => {
    if (shouldFocus) {
      addKeyListener();
    } else {
      removeKeyListener();
    }
    return () => removeKeyListener();
  }, [shouldFocus, selectedIndex, scrolling]);

  const lastFetchedRowRef = useRef(null);
  const lastFetchedPageRef = useRef(null);
  const fetchingRef = useRef(false);

  useEffect(() => {
    const currentRow = data?.[currentRowIndex];
    if (!currentRow || fetchingRef.current || state.isLoading) return;

    const isNearEnd = selectdIndx >= currentRow.list.length - 3;
    console.log("isNearEnd", isNearEnd);
    if (isNearEnd) {
      console.log("isNearEnd", isNearEnd);
      return;
    }

    const isNewRow = state.currentRowIndex !== currentRowIndex;
    const playlistId = currentRow.id;
    const currentPage = isNewRow ? 2 : state.pageNumber;

    if (
      lastFetchedRowRef.current === currentRowIndex &&
      lastFetchedPageRef.current === currentPage
    ) {
      return;
    }

    fetchingRef.current = true;
    lastFetchedRowRef.current = currentRowIndex;
    lastFetchedPageRef.current = currentPage;

    setState((prev) => ({
      ...prev,
      currentRowIndex,
      pageNumber: currentPage,
      isLoading: true,
    }));

    let Tempdata = [...data[0].list];

    const fetchPaginationData = async () => {
      try {
        const myHeaders = {
          platform: "0",
          iskid: "0",
          age: "12",
          country: localStorage.getItem("country"),
          isDefault: "1",
          Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
          "Content-Type": "application/json",
        };

        const response = await getplaylistVideo(playlistId, currentPage);

        const newItems = Array.isArray(response?.data) ? response.data : [];

        if (newItems.length > 0) {
          const updatedData = [...data];
          const rowIndex = updatedData.findIndex(
            (row) => row.id === playlistId
          );

          if (rowIndex >= 0) {
            const existingIds = new Set(
              updatedData[rowIndex].list.map((item) => item.id)
            );
            const filteredNewItems = newItems.filter(
              (item) => !existingIds.has(item.id)
            );

            if (filteredNewItems.length > 0) {
              let tempupdateData = updateData;
              for (let i = 0; i < updateData[rowIndex].list?.length; i++) {
                if (updateData[rowIndex].list[i]?.firstEntry) {
                  if (i > 0) {
                    tempupdateData[rowIndex].list = [
                      ...updateData[rowIndex].list?.slice(0, i - 1),
                      ...filteredNewItems,
                      ...updateData[rowIndex].list?.slice(i - 1),
                    ];
                  } else {
                    tempupdateData[rowIndex].list = [
                      ...updateData[rowIndex].list?.slice(0, i - 1),
                      ...filteredNewItems,
                    ];
                  }
                  break;
                }
              }
              onDataUpdate(tempupdateData);

              setState((prev) => ({
                ...prev,
                pageNumber: currentPage + 1,
                isLoading: false,
                data: tempupdateData,
              }));
            } else {
              console.log("No unique items to append.");
              setState((prev) => ({ ...prev, isLoading: false }));
            }
          }
        } else {
          console.log("No data from API. Pagination done.");
          setState((prev) => ({ ...prev, isLoading: false }));
        }
      } catch (err) {
        console.error("Pagination fetch error:", err);
        setState((prev) => ({ ...prev, isLoading: false }));
      } finally {
        fetchingRef.current = false;
      }
    };

    fetchPaginationData();
  }, [selectdIndx, data]);

  // Cleanup effect
  useEffect(() => {
    return () => {
      // Cleanup all timers on unmount
      if (bgVideoTimerRef.current) {
        clearTimeout(bgVideoTimerRef.current);
        bgVideoTimerRef.current = null;
      }
      
      // Cleanup animation frames if any
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
        animationFrameRef.current = null;
      }
      
      // Remove all event listeners
      if (keyListenerRef.current) {
        window.removeEventListener("keydown", keyListenerRef.current);
        keyListenerRef.current = null;
      }
      
      // Stop any jQuery animations
      $("#grid").stop(true, true);
      $(`.grid-row-${currentRowIndex}`).stop(true, true);
    };
  }, []);

  function convertSecondsToReadableTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    if (hours > 0) {
      return `${hours}h ${minutes}m Left`;
    } else {
      return `${minutes}m Left`;
    }
  }

  const selectedStyle =
    selectionStyle === "border"
      ? {
        outline: shouldFocus ? `5px solid #fff` : `0px solid transparent`,
      }
      : { transform: "scale(1.1)" };

  const handleBackButton = () => {
    if (isChild) navigate("HomeScreen");
  };

  function capitalizeFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const navigateToScreen = (p, p1) => {
    console.log("Navigating to screen:", p, p1);
    navigate(p, p1);
  };

  const lastFocusedElement3 = () => {
    console.log("lastFocusedElement1....", shouldFocusSlider);
    setState((prevState) => ({
      ...prevState,
      lastFocusedElement: shouldFocusSlider ? "Slider" : "AnimatedGrid",
    }));
  };

  const AnimatedGrid_Navigate = (p) => {
    setState((prevState) => ({
      ...prevState,
      griddata: null,
      shouldFocusToGrid: false,
    }));
    window.removeEventListener("keydown", handleKeyDown);
    navigateScreen("HomePage");
  };

  console.log(sliderData, "SLiderDAta");
  let userDetails = JSON.parse(localStorage.getItem("user_details"));
  let userProfile = userDetails?.user_profiles?.[0];
  let subscriptionCheck =
    userProfile !== undefined && userProfile?.subscriptions?.length !== 0;

  const genres =
    data[currentRowIndex]?.list[selectedIndex.col]?.genres?.split(",") || [];
  const [item1, item2, item3] = genres;

  return (
    <div>
      {griddata ? (
        <AppInApp
          appinappData={appinappData}
          isChild={true}
          itemDetails={griddata}
          columnCount={resolution === "FHD" ? 7 : 7}
          rowHeight={resolution === "FHD" ? 373 : 249}
          rowWidth={"100%"}
          columnWidth={resolution === "FHD" ? 238 : 159}
          columnHeight={resolution === "FHD" ? 300 : 200}
          thumbnailWidth={resolution === "FHD" ? 228 : 142}
          thumbnailHeight={resolution === "FHD" ? 291 : 194}
          gapX={8.5}
          gapY={0}
          selectionColor={"#FF671F"}
          scrollDuration={100}
          defaultRowCount={1}
          horizontalScrollStartIndex={1}
          selectionStyle={"border"}
          gridContainerX={resolution === "FHD" ? "118px" : "79px"}
          gridContainerY={"65.5vh"}
          gridContainerWidth={"95vw"}
          gridContainerHeight={"90vh"}
          gridContainerBgColor={"transparent"}
          shouldFocus={shouldFocusToGrid}
          navigate={navigateToScreen}
          FocusHandler={FocusHandler}
          callBack={callBack}
          navigateScreen={AnimatedGrid_Navigate}
          rememberFocus={selectedIndex}
          setRememberFocus={setRememberFocus}
        />
      ) : (
        <div
          style={{
            position: "absolute",
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
            margin: "0px",
          }}
        >
          <div
            className="grid-parent-container"
            style={{
              position: "absolute",
              overflow: "hidden",
              backgroundColor: gridContainerBgColor,
              top: gridContainerY,
              left: gridContainerX,
              width: gridContainerWidth,
              height: gridContainerHeight,
            }}
          >
            {console.log("hide banner", data)}
            {shouldShowBanner ? (
              <div
                onMouseEnter={() => {
                  if (!shouldFocusSlider) {
                    FocusHandler("Slider");
                  }
                }}>
                <SliderBanner
                  isLoading={state.isLoading}
                  sliderData={sliderData}
                  shouldFocusSlider={shouldFocusSlider}
                  shouldFocusToGrid={shouldFocus}
                  FocusHandler={FocusHandler}
                  navigateToScreen={navigateToScreen}
                  callBack={callBack}
                  lastFocusedElement3={lastFocusedElement3}
                  rememberFocus={rememberFocus}
                  setRememberFocus={setRememberFocus}
                  lastFocusedElement={lastFocusedElement}
                />
              </div>
            ) : (
              ""
            )}
            <div
              id="grid"
              className="grid"
              style={{
                top: "15px",
                left: "0",
                display: "flex",
                flexDirection: "column",
                height: rowHeight + "px",
                width: rowWidth,
              }}
            >
              {data
                ?.slice(currentRowIndex, currentRowIndex + 4)
                ?.map((rowData, rowOffset) =>
                  rowData && rowData.list ? (
                    <div
                      key={`row-${currentRowIndex + rowOffset}`}
                      id={`parentdiv-${currentRowIndex + rowOffset}`}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: resolution === "FHD" ? "10px" : "7px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        id={`firstchild-${currentRowIndex + rowOffset}`}
                        className="category-title"
                        style={{
                          textAlign: "left",
                          fontWeight: "bold",
                          color: "white",
                          width: resolution === "FHD" ? "850px" : "567px",
                          position: "absolute",
                          marginTop:
                            platform === "webOS"
                              ? resolution === "FHD"
                                ? `${-340 + rowOffset * 100}px`
                                : `${-119 + rowOffset * 70}px`
                              : resolution === "FHD"
                                ? `${-345}px`
                                : `${-237}px`,
                          marginLeft: resolution === "FHD" ? "10px" : "7px",
                          fontSize: resolution === "FHD" ? "24px" : "18px",
                        }}
                      >
                        {rowData.title &&
                          rowData.title.length > 0 &&
                          rowData.title[0] !== undefined &&
                          rowData.title[0].content !== undefined &&
                          rowData.title[0].content !== "" &&
                          rowData.title.find(
                            (item) =>
                              item.language ===
                              localStorage.getItem("AppLanguage")
                          )
                          ? capitalizeFirstLetter(
                            rowData?.title?.find(
                              (item) =>
                                item.language ==
                                localStorage.getItem("AppLanguage")
                            )?.content ||
                            rowData?.title?.[0]?.content ||
                            rowData?.title?.[0]?.content
                          )
                          : ""}
                      </div>
                      <div
                        id={`rowofitem-${currentRowIndex + rowOffset}`}
                        className={`grid-row grid-row-${currentRowIndex + rowOffset}`}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          height: rowHeight,
                          gap: `${gapY}px ${gapX}px`,
                        }}
                      >
                        {rowData.list.map((show, colIndex) => (
                          <div
                            key={colIndex}
                            onMouseEnter={() => {
                              setSelectedIndex({
                                row: currentRowIndex + rowOffset,
                                col: colIndex,
                              });
                              setState((prevState) => ({
                                ...prevState,
                                BgImage: show.detail_banner
                                  ? show.detail_banner
                                  : show.poster_url,
                                shouldShowBGimage: true,
                                shouldShowBGVideo: false,
                                tarilerURL: show.file_url,
                                selectdIndx: colIndex,
                              }));
                            }}
                            className={`grid-item ${selectedIndex.row ===
                                currentRowIndex + rowOffset &&
                                selectedIndex.col === colIndex
                                ? "selected"
                                : ""
                              }`}
                            style={{
                              margin: resolution === "FHD" ? "5px" : "3px",
                              width:
                                rowData.playlist_type === "aggregator" ||
                                  rowData.playlist_type === "RecommededFeed" ||
                                  rowData.playlist_type === "continue_watching" ||
                                  rowData.playlist_type === "content_language" ||
                                  rowData.playlist_type === "popular_genres"
                                  ? "430px"
                                  : rowData.playlist_type !== "trending"
                                    ? columnWidth
                                    : 240,
                              height: columnHeight,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: "transparent",
                              position: "relative",
                              borderRadius: "10px",
                            }}
                          >
                            {console.log("show:", show)}
                            {show.isTeaser === 1 &&
                              (() => {
                                const startTime =
                                  parseInt(show?.endtime) * 1000;
                                const now = Date.now();
                                const hoursRemaining =
                                  (startTime - now) / (1000 * 60 * 60);
                                const launchesIn24Hours =
                                  hoursRemaining > 0 && hoursRemaining <= 48;

                                return launchesIn24Hours ? (
                                  <div
                                    style={{
                                      position: "absolute",
                                      bottom: "10%",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      zIndex: 1,
                                      background: "#fff",
                                      color: "black",
                                      padding: "5px 15px",
                                      fontSize: "16px",
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    {`LAUNCHES IN ${Math.ceil(
                                      hoursRemaining
                                    )} HOURS`}
                                  </div>
                                ) : null;
                              })()}
                            {show?.isTeaser === 1 && (
                              <img
                                src={upcomingImg}
                                alt={show.title}
                                style={{
                                  borderRadius: "10px",
                                  position: "absolute",
                                  width: "6vw",
                                  height: "4vh",
                                  top: "0.7vh",
                                  left: ".7rem",
                                  zIndex: 1,
                                }}
                              />
                            )}
                            {rowData.playlist_type === "continue_watching" && (
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: "4px",
                                  left: "0px",
                                  width: "100%",
                                  height: "8px",
                                  backgroundColor: "#444",
                                  borderRadius: "0px 0px 10px 7px",
                                  overflow: "hidden",
                                  zIndex: 2,
                                  boxSizing: "border-box",
                                }}
                              >
                                <div
                                  style={{
                                    width: `${show.video_duration && show.paused_at
                                        ? (show.paused_at /
                                          show.video_duration) *
                                        100
                                        : 0
                                      }%`,
                                    height: "100%",
                                    backgroundColor: "#EC008C",
                                    borderRadius: "3px",
                                    transition: "width 0.3s ease",
                                  }}
                                />
                              </div>
                            )}

                            {rowData.playlist_type === "continue_watching" && (
                              <div
                                style={{
                                  position: "absolute",
                                  zIndex: 9,
                                  bottom: "-60px",
                                  left: "0px",
                                  marginLeft: "0px",
                                }}
                              >
                                {console.log("show.title:", show)}
                                <div
                                  style={{
                                    color: "#fff",
                                    fontSize: "20px",
                                  }}
                                >
                                  {show?.title?.length > 61 ? (
                                    <marquee
                                      behavior="scroll"
                                      direction="left"
                                      scrollAmount="4"
                                    >
                                      {show.title}
                                    </marquee>
                                  ) : (
                                    <div style={{ width: "414px", whiteSpace: "nowrap", overflow: "hidden" }}>
        {show.category_title === "Shows" && show?.s_No && show?.ep_No
                                         ? ` S${show?.s_No ?? 0} E${show?.ep_No ?? 0} ${show?.title ?? ""} `
                                        : show?.title ?? ""}
                                    </div>
                                  )}
                                </div>
                                <span style={{
                                  color: "#fff",
                                  fontSize: "20px",
                                }}>
                                  {convertSecondsToReadableTime(
                                    show.video_duration - show.paused_at
                                  )}
                                </span>
                              </div>
                            )}
                            <Wrapper
                              className="animated-grid-image3"
                              as="img"
                              onError={(e) => {
                                if (e.target.src !== default_vertical_img) {
                                  e.target.src = default_vertical_img;
                                  e.target.alt = "Image failed to load";
                                }
                              }}
                              onClick={() =>
                                handleOk(currentRowIndex + rowOffset, colIndex)
                              }
                              decoding="async"
                              loading="lazy"
                              src={
                                rowData.playlist_type === "trending"
                                  ? show.thumbnail
                                    ? show.thumbnail
                                    : default_vertical_img
                                  : rowData.playlist_type ===
                                    "continue_watching"
                                    ? show.detail_banner
                                      ? show.detail_banner
                                      : show.poster_url
                                        ? show.poster_url
                                        : default_horizontal_img
                                    : rowData.playlist_type === "content_language"
                                      ? show.thumbnail
                                        ? show.thumbnail
                                        : default_horizontal_img
                                      : rowData.playlist_type === "RecommededFeed"
                                        ? show.poster_url
                                          ? show.poster_url
                                          : default_horizontal_img
                                        : rowData.playlist_type === "popular_genres"
                                          ? show.thumbnail
                                            ? show.thumbnail
                                            : default_horizontal_img
                                          : rowData.playlist_type === "aggregator"
                                            ? show.thumbnail
                                              ? show.thumbnail
                                              : default_horizontal_img
                                            : show.thumbnail
                                              ? show.thumbnail
                                              : default_vertical_img
                              }
                              alt={show.title}
                              style={{
                                width:
                                  rowData.playlist_type === "RecommededFeed" ||
                                    rowData.playlist_type === "aggregator" ||
                                    rowData.playlist_type === "popular_genres" ||
                                    rowData.playlist_type ===
                                    "continue_watching" ||
                                    rowData.playlist_type === "content_language"
                                    ? "430px"
                                    : rowData.playlist_type === "trending"
                                      ? "240px"
                                      : thumbnailWidth,
                                height: thumbnailHeight,
                                borderRadius: "10px",
                                position: "absolute",
                                ...(selectedIndex.row ===
                                  currentRowIndex + rowOffset &&
                                  selectedIndex.col === colIndex
                                  ? selectedStyle
                                  : {}),
                              }}
                            />

                            {show?.type_id === "view_all" && (
                              <img
                                src={view_all}
                                alt="View Icon"
                                style={{
                                  position: "absolute",
                                  width: "20rem",
                                  height: "27rem",
                                }}
                              />
                            )}
                            {show?.is_paid === 1 && (
                              <img
                                src={premium}
                                alt="Premium Icon"
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  width: "4rem",
                                  height: "4rem",
                                }}
                              />
                            )}
                            {(show?.is_paid === 2 || show?.is_paid === 3) && (
                              <img
                                src={rent}
                                alt="Rent Icon"
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  width: "4rem",
                                  height: "4rem",
                                }}
                              />
                            )}
                            {show?.is_live == 1 && (
                              <img
                                src={imgLive}
                                alt="live Icon"
                                style={{
                                  position: "absolute",
                                  bottom: "14rem",
                                  left: ".7rem",
                                  width: "4rem",
                                  height: "2rem",
                                  top: "0.7rem",
                                }}
                              />)}
                            {rowData.playlist_type === "trending" ? (
                              <img
                                className="animated-grid-image2"
                                src={images[colIndex]}
                                style={{
                                  position: "absolute",
                                  marginLeft: images[colIndex] === ten ? "-158px" : "-225px",
                                  marginTop: "205px",
                                }}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : null
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

AnimatedGrid.setFocus = (focus) => {
  if (typeof addKeyListener === "function") {
    addKeyListener();
  }
};

AnimatedGrid.setFocusDefault = () => {
  if (typeof setFocusToDefault === "function") {
    setFocusToDefault();
  }
};

AnimatedGrid.clearCurrentKeyListener = () => {
  if (typeof RemoveCurrentKeyListener === "function") {
    RemoveCurrentKeyListener();
  }
};

AnimatedGrid.onOKPress = () => {
  if (typeof ShowAppInAppSection === "function") {
    ShowAppInAppSection();
  }
};

export default AnimatedGrid;
